"use strict";

exports.__esModule = true;
exports.DeviceRoutesPlantTwin = DeviceRoutesPlantTwin;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _DeviceCollection = require("../DeviceCollection");
var _System = require("../../../System");
var _reactRouterPathGroup = require("../../../Utils/reactRouterPathGroup");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _DeviceListScreenPlantTwin = require("../DeviceListScreenPlantTwin");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Devices Route
 */
function DeviceRoutesPlantTwin() {
  var active = (0, _reactRouterPathGroup.usePathGroupActive)([(0, _System.getScreenPath)("DeviceListPlantTwin")]);
  if (!active) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_DeviceCollection.DeviceCollection, null, function (collection) {
    return /*#__PURE__*/_react["default"].createElement(_DeviceCollection.DeviceCollectionContext.Provider, {
      value: collection
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: (0, _System.getScreenPath)("DeviceListPlantTwin") + "/*",
      element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
        component: _DeviceListScreenPlantTwin.DeviceListScreenPlantTwin
      })
    })));
  });
}